import BuildingType from "@/roc/building/BuildingType";
import BuildingMaxLevel from "@/roc/building/BuildingMaxLevel";
import Effects from '@/roc/effects/Effects';
import ProductionQueue from '@/roc/effects/Production/ProductionQueue';
import ProductionWorkforce from '@/roc/effects/Production/ProductionWorkforce';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import Happiness from "@/roc/effects/CultureBonus/Happiness";
const _productionRates = {
    1: { short: 2300, medium: null, long: null },
    2: { short: 2400, medium: 4100, long: null },
    3: { short: 3300, medium: 5300, long: null },
    4: { short: 3900, medium: 5900, long: 7000 },
    5: { short: 5000, medium: 7300, long: 8300 },
    6: { short: 5800, medium: 9600, long: 11000 },
    7: { short: 7150, medium: 11800, long: 13700 },
    8: { short: 7510, medium: 12400, long: 14400 },
    9: { short: 7890, medium: 13000, long: 15100 },
    10: { short: 8680, medium: 14300, long: 16600 },
    11: { short: 9110, medium: 15000, long: 17400 },
    12: { short: 9570, medium: 15800, long: 18300 },
    13: { short: 10300, medium: 17100, long: 19800 },
    14: { short: 10700, medium: 17800, long: 20600 },
    15: { short: 11100, medium: 18500, long: 21400 },
    16: { short: 12000, medium: 20000, long: 23100 },
    17: { short: 12500, medium: 20800, long: 24000 },
    18: { short: 13000, medium: 21600, long: 25000 },
    19: { short: 14000, medium: 23300, long: 27000 },
    20: { short: 14600, medium: 24200, long: 28100 },
    21: { short: 15200, medium: 25200, long: 29200 },
    22: { short: 16300, medium: 27000, long: 31200 },
    23: { short: 16800, medium: 27800, long: 32100 },
    24: { short: 17300, medium: 28600, long: 33100 },
    25: { short: 18500, medium: 30600, long: 35400 },
    26: { short: 19100, medium: 31500, long: 36500 },
    27: { short: 19700, medium: 32400, long: 37600 },
    28: { short: 21100, medium: 34700, long: 40200 },
    29: { short: 21700, medium: 35700, long: 41400 },
    30: { short: 22400, medium: 36800, long: 42600 },
    31: { short: 24000, medium: 39400, long: 45600 },
    32: { short: 24700, medium: 40600, long: 47000 },
    33: { short: 25400, medium: 41800, long: 48400 },
    34: { short: 27200, medium: 44700, long: 51800 },
    35: { short: 28000, medium: 46000, long: 53400 },
    36: { short: 28800, medium: 47400, long: 55000 },
    37: { short: 31000, medium: 49600, long: 59520 },
    38: { short: 32500, medium: 52000, long: 62400 },
    39: { short: 34000, medium: 54400, long: 65280 },
    40: { short: 35500, medium: 56800, long: 68160 },
    41: { short: 37000, medium: 59200, long: 71040 },
    42: { short: 38500, medium: 61600, long: 73920 },
};
const DomesticFarm = {
    id: "5",
    name: "Domestic Farm",
    width: 4,
    height: 4,
    type: BuildingType.FARM,
    era: "stoneAge",
    icon: "Food",
    minLevel: 1,
    maxLevel: BuildingMaxLevel.THREE_OFF,
    url: 'https://riseofcultures.wiki.gg/wiki/Home_Cultures/Farms/Domestic_Farm',
    flags: 0,
    counts: {
        stoneAge: 2,
        bronzeAge: 3,
        minoanEra: 4,
        classicGreece: 5,
        earlyRome: 6,
        romanEmpire: 7,
        byzantineEra: 8,
        ageOfTheFranks: 8,
        feudalAge: 9,
        iberianEra: 9,
        kingdomOfSicily: 10,
        highMiddleAges: 10,
        earlyGothicEra: 11,
        lateGothicEra: 11,
    },
    effects: Effects.create([
        new ProductionQueue(ProductionWorkforce.asCallbackWithLevel((level) => {
            if (level <= 2) {
                return 1;
            }
            if (level <= 4) {
                return 2;
            }
            if (level === 5) {
                return 3;
            }
            if (level === 6) {
                return 4;
            }
            return 5;
        }), [], ProductionDuration.asFlat(2 * 60 * 60), ProductionOutput.asCallbackWithLevel((level) => {
            return _productionRates[level].short;
        }).withOutput(ProductionOutputType.FOOD)),
        new ProductionQueue(ProductionWorkforce.asCallbackWithLevel((level) => {
            if (level <= 2) {
                return 1;
            }
            if (level <= 4) {
                return 2;
            }
            if (level === 5) {
                return 3;
            }
            if (level === 6) {
                return 4;
            }
            return 5;
        }), [], ProductionDuration.asFlat(4 * 60 * 60), ProductionOutput.asCallbackWithLevel((level) => {
            return _productionRates[level].medium;
        }).withOutput(ProductionOutputType.FOOD)),
        new ProductionQueue(ProductionWorkforce.asCallbackWithLevel((level) => {
            if (level <= 2) {
                return 1;
            }
            if (level <= 4) {
                return 2;
            }
            if (level === 5) {
                return 3;
            }
            if (level === 6) {
                return 4;
            }
            return 5;
        }), [], ProductionDuration.asFlat(6 * 60 * 60), ProductionOutput.asCallbackWithLevel((level) => {
            return _productionRates[level].long;
        }).withOutput(ProductionOutputType.FOOD)),
        new Happiness({
            stoneAge: [120, 240, 480],
            bronzeAge: [180, 360, 720],
            minoanEra: [240, 480, 960],
            classicGreece: [320, 640, 1280],
            earlyRome: [400, 800, 1600],
            romanEmpire: [480, 960, 1920],
            byzantineEra: [560, 1120, 2240],
            ageOfTheFranks: [680, 1360, 2720],
            feudalAge: [800, 1600, 3200],
            iberianEra: [960, 1920, 3840],
            kingdomOfSicily: [1160, 2320, 4640],
            highMiddleAges: [1400, 2800, 5600],
            earlyGothicEra: [1680, 3360, 6720],
            lateGothicEra: [1960, 3920, 7740],
        }),
    ]),
};
export default DomesticFarm;
